import {createEventBus} from '@malt/vue-event-bus/src/create-event-bus';
import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';

type Events = {
    'creation:experience-level-updated': undefined;
    'creation:location-updated': undefined;
    'creation:focus-changed': TipsPart;
    'wizard:description-focus': undefined;
    'wizard:languages-focus': undefined;
    'wizard:profile-photo-updated': any;
};

export const eventBusProfileCreationWizard = createEventBus<Events>();
